import { Chip, Box, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getPath } from '../../pages/Pages';
import { chipColors } from '../../lib/contrast';

type Facility = {
    id: string | number;
    name: string;
};

type Props = {
    facilities: Facility[];
    maxWidth?: string | number;
    onFacilityClick?: (facility: Facility) => void;
};

export function SttChipFacilityRow({
    facilities,
    maxWidth = 'auto',
    onFacilityClick,
}: Props): React.ReactElement {
    const navigate = useNavigate();

    /**
     * Get initials
     */
    const getInitials = (name: string): string => {
        if (!name) {
            return '';
        }

        const words = name.split(' ');
        const result: string[] = [];
        words.forEach((word: any) => {
            // Ignorar palabras vacías y caracteres especiales
            if (word && !['-', '(', ')', '[', ']', '{', '}'].includes(word)) {
                const firstChar = word.charAt(0);
                // Solo añadir si es una letra o número
                if (/[a-zA-Z0-9]/.test(firstChar)) {
                    result.push(firstChar.toUpperCase());
                }
            }
        });

        return result.join('');
    };

    const handleClick = (facility: Facility): void => {
        if (onFacilityClick) {
            onFacilityClick(facility);
        } else {
            navigate(getPath('facilities'));
        }
    };

    // -----| Render |-----
    return (
        <Box
            display="flex"
            justifyContent="center"
            maxWidth={maxWidth}
            flexWrap="wrap"
        >
            {facilities &&
                facilities.map((facility: any, idx: any) => (
                    <Box key={idx} mr={1} mt={1}>
                        <Tooltip title={facility.name}>
                            <Chip
                                size="small"
                                label={getInitials(facility.name)}
                                onClick={() => handleClick(facility)}
                                sx={{
                                    cursor: 'pointer',
                                    '&:hover': {
                                        ...chipColors('primary.light'),
                                    },
                                }}
                            />
                        </Tooltip>
                    </Box>
                ))}
        </Box>
    );
}
